<micro-lookup domain="q" obj="queueCarriers" url="/q/queueCarriers" [key]="queueCarrierId"></micro-lookup>
